import ButtonTableAction from '../../../../components/buttons/ButtonTableAction';
import DefaultDataTable from '../../../../components/default/DefaultDataTable';
import ActiveControl from '../../../../components/ActiveControl';

import { Bank, BankFilters } from '../../../../app/models/Bank';
import { Currency, CurrencyFilters } from '../../../../app/models/Currency';
import CurrencySwitchChange from '../CurrencySwitchChange';

interface Props {
    currencies: Currency[];
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    active?: (id: number, active: boolean) => void;
    show?: (id: number) => void;
    filter: CurrencyFilters;
    setFilter: (filter: CurrencyFilters) => void;
    paginationRowsPerPageOptions?: any[];
    callbackSuccess: () => void;
}

const CurrencyDataTable = ({
    currencies,
    totalRows,
    loading = false,
    edit,
    active,
    show,
    filter,
    setFilter,
    callbackSuccess
}: Props) => {
    const columns = [
        {
            name: 'Id',
            selector: (row: any) => row.id,
            sortable: true,
            sortField: 'id',
            cell: (row: Currency, index: any, column: any) => <span className="">{row.id}</span>
        },
        {
            name: 'Nombre',
            selector: (row: any) => row.name,
            sortable: true,
            sortField: 'name',
            cell: (row: Currency, index: any, column: any) => <span className="">{row.name}</span>
        },
        {
            name: 'Código ISO',
            selector: (row: any) => row.iso_code,
            sortable: true,
            sortField: 'iso_code',
            width: '120px',
            cell: (row: Currency, index: any, column: any) => (
                <span className="">{row.iso_code}</span>
            )
        },
        {
            name: 'Activo',
            selector: (row: any) => row.is_active,
            sortable: true,
            sortField: 'is_active',
            cell: (row: Currency, index: any, column: any) => (
                <CurrencySwitchChange
                    checkValue={row.is_active ?? true}
                    currencyId={row.id!}
                    callbackSuccess={callbackSuccess!}
                />
            )
        },
        {
            name: 'Acciones',
            selector: (row: any) => row.id,
            sortable: false,
            cell: (row: Currency, index: any, column: any) => (
                <div className="">
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? -1)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            errorMessage={'No se puede editar este registro.'}
                            title={'Editar'}
                        />
                    )}
                </div>
            )
        }
    ];

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    {/* <BankFilters filter={filter} setFilter={setFilter} /> */}
                </div>
            </div>

            <DefaultDataTable
                columns={columns}
                data={currencies}
                progressPending={loading}
                paginationTotalRows={totalRows}
                filter={filter}
                setFilter={setFilter}
            />
        </>
    );
};

export default CurrencyDataTable;
